import i18next from 'i18next';
import enGB from '@locales/navigation/enGB';
import deAT from '@locales/navigation/deAT';
import { authModules } from 'app/auth';
i18next.addResourceBundle('enGB', 'navigation', enGB);
i18next.addResourceBundle('deAT', 'navigation', deAT);

const navigationConfig = [
	{
		id: 'timelite',
		title: 'TimeLite',
		type: 'group',
		auth: authModules.tl_default,
		children: [
			{
				id: 'tl_overview',
				title: 'Overview',
				translate: 'OVERVIEW',
				type: 'item',
				icon: 'dashboard',
				url: '/tl/overview',
				auth: authModules.tl_default
			},
			{
				id: 'tl_calendar',
				title: 'Calendar',
				translate: 'CALENDAR',
				type: 'item',
				icon: 'calendar_today',
				url: '/tl/calendar',
				auth: authModules.tl_default
			},
			{
				id: 'tl_requests',
				title: 'Requests',
				translate: 'REQUESTS',
				type: 'item',
				icon: 'assignment',
				url: '/tl/requests',
				auth: authModules.tl_default
			},
			{
				id: 'tl_reports',
				title: 'Reports',
				translate: 'REPORTS',
				type: 'item',
				icon: 'assessment',
				url: '/tl/reports?tab=m',
				auth: authModules.tl_default
			}
		],
	},
	{
		id: 'persomat',
		title: 'Persomat',
		type: 'group',
		auth: authModules.pm_default,
		children: [
			{
				id: 'pm_overview',
				title: 'Overview',
				translate: 'OVERVIEW',
				type: 'item',
				icon: 'dashboard',
				url: '/pm/overview',
				auth: authModules.pm_default
			},
		]
	},
	{
		id: 'billbuddy',
		title: 'BillBuddy',
		type: 'group',
		auth: authModules.bb_default,
		children: [
			{
				id: 'bb_overview',
				title: 'Overview',
				translate: 'OVERVIEW',
				type: 'item',
				icon: 'dashboard',
				url: '/bb/overview',
				auth: authModules.bb_default
			},
		]
	},
	{
		id: 'exkursio',
		title: 'Exkursio',
		type: 'group',
		auth: authModules.eo_default,
		children: [
			{
				id: 'eo_overview',
				title: 'Overview',
				translate: 'OVERVIEW',
				type: 'item',
				icon: 'dashboard',
				url: '/eo/overview',
				auth: authModules.eo_default
			},
			{
				id: 'eo_trips',
				title: 'Trips',
				translate: 'TRIPS',
				type: 'item',
				icon: 'map',
				url: '/eo/trips',
				auth: authModules.eo_default
			},
			{
				id: 'eo_vehicles',
				title: 'Vehicles',
				translate: 'VEHICLES',
				type: 'item',
				icon: 'directions_car',
				url: '/eo/vehicles',
				auth: authModules.eo_default
			},
			{
				id: 'eo_reports',
				title: 'Reports',
				translate: 'REPORTS',
				type: 'item',
				icon: 'assessment',
				url: '/eo/reports?tab=m&type=t',
				auth: authModules.eo_default
			},
		]
	},
	{
		id: 'inventurius',
		title: 'Inventurius',
		type: 'group',
		auth: authModules.iv_default,
		children: [
			{
				id: 'iv_overview',
				title: 'Overview',
				translate: 'OVERVIEW',
				type: 'item',
				icon: 'dashboard',
				url: '/iv/overview',
				auth: authModules.iv_default
			},
		]
	},
	// {
	// 	id: 'academy',
	// 	title: 'Academy',
	// 	type: 'group',
	// 	children: [
	// 	]
	// },
	// {
	// 	type: 'divider',
	// 	id: 'divider-1'
	// },
	{
		id: 'abs',
		title: 'Business Suite',
		type: 'group',
		auth: authModules.abs_admin,
		children: [
			{
				id: 'abs_administration',
				title: 'Administration',
				translate: 'ADMINISTRATION',
				type: 'item',
				icon: 'room_preferences',
				url: '/administration',
				auth: authModules.abs_admin,
				// badge: {
				// 	title: 10,
				// 	bg: '#525E8A',
				// 	fg: '#FFFFFF'
				// },
			},
		]
	},
];

export default navigationConfig;
